var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(8 8)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4902 16.2156C12.3699 16.0876 12.2038 16.0123 12.0283 16.006C11.8527 15.9998 11.6817 16.0631 11.5525 16.1822C11.4234 16.3014 11.3465 16.4667 11.3386 16.6422C11.3306 16.8178 11.3923 16.9893 11.5102 17.1196L13.9182 19.7323C14.2762 20.0829 14.8096 20.0829 15.1409 19.7523L15.3836 19.5129C16.2599 18.6511 17.1353 17.7882 18.0096 16.9243L18.0362 16.8976C18.8534 16.0923 19.6663 15.2827 20.4749 14.4689C20.5958 14.3424 20.662 14.1734 20.6594 13.9985C20.6568 13.8235 20.5855 13.6566 20.4609 13.5337C20.3363 13.4109 20.1684 13.3419 19.9934 13.3418C19.8184 13.3416 19.6504 13.4103 19.5256 13.5329C18.7207 14.3425 17.9118 15.1481 17.0989 15.9496L17.0722 15.9763C16.2344 16.8045 15.3955 17.6316 14.5556 18.4576L12.4902 16.2156Z",
    fill: "#F6FAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmQuote);
export default __webpack_public_path__ + "static/media/confirmQuote.8969fe1de51545757681456ca93246e7.svg";
export { ForwardRef as ReactComponent };